import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupport = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "customer-service-2-line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.7194 8.28516H21.7812C22.8858 8.28516 23.7812 9.18059 23.7812 10.2852V14.2852C23.7812 15.3898 22.8858 16.2852 21.7812 16.2852H20.7194C20.2273 20.2315 16.8608 23.2852 12.7812 23.2852V21.2852C16.0949 21.2852 18.7812 18.5989 18.7812 15.2852V9.28516C18.7812 5.97145 16.0949 3.28516 12.7812 3.28516C9.46754 3.28516 6.78125 5.97145 6.78125 9.28516V16.2852H3.78125C2.67668 16.2852 1.78125 15.3898 1.78125 14.2852V10.2852C1.78125 9.18059 2.67668 8.28516 3.78125 8.28516H4.84314C5.33524 4.33885 8.70163 1.28516 12.7812 1.28516C16.8608 1.28516 20.2273 4.33885 20.7194 8.28516ZM3.78125 10.2852V14.2852H4.78125V10.2852H3.78125ZM20.7812 10.2852V14.2852H21.7812V10.2852H20.7812ZM8.54069 16.0701L9.60083 14.3739C10.5229 14.9514 11.613 15.2852 12.7812 15.2852C13.9495 15.2852 15.0396 14.9514 15.9616 14.3739L17.0219 16.0701C15.7925 16.8401 14.3389 17.2852 12.7812 17.2852C11.2236 17.2852 9.77007 16.8401 8.54069 16.0701Z",
			fill: "white"
		})
	})
});
const ForwardRef = forwardRef(SvgSupport);
export default ForwardRef;
